import { Component, OnInit } from '@angular/core';
import { NgForm, FormsModule } from "@angular/forms";
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;

@Component({
  selector: 'app-matchday',
  templateUrl: './matchday.component.html',
  styleUrls: ['./matchday.component.scss']
})
export class MatchdayComponent implements OnInit {

  attendanceRequest: any = {};
	attendanceError: any;
  attendanceSuccess: any;
  matchesList: any = "";
  titleList: any = "";
  selectedmatch: any = "";
  addcolrow: any = 1;
  firstname: any = "";
  lastname: any = "";
  mobilenumber: any = "";
  emailaddress: any = "";
  address: any = "";
  constructor(private allpagesService: AllPageService,) { }

  ngOnInit() {
    this.allpagesService.getMatchelistwithout().then((data: any) => {
			this.matchesList = data;
    //  this.selectedmatch = data.data[0].matche_id;
      //this.attendanceRequest.matche_id = this.selectedmatch;
			//console.warn(this.matchesList);
		});

    this.allpagesService.Addattendancetitle().then((data: any) => {
			this.titleList = data;
      //this.selectedmatch = data.data[0].matche_id;
      //this.attendanceRequest.matche_id = this.selectedmatch;
			console.warn(this.titleList);
		});
  }

  selectmatch() {
    this.selectedmatch = jQuery("#select_match").val();
    this.attendanceRequest.attendance_title_id = this.selectedmatch;
    console.warn(this.selectedmatch);   
  
  }

  addcol(){

    this.addcolrow = parseInt(this.addcolrow) + 1;
    console.log(this.addcolrow);
    jQuery(".bottom-main").append(" <div class='matchday-bottom-inner'><div class='matchday-center-attendee full mb'> <p>ATTENDEE  "+this.addcolrow+"</p></div> <div class='matchday-top-input-box half mr mb'><input type='text' placeholder='First Name' id='firstname"+this.addcolrow+"' class='input-style firstname'><div class='invalid-feedback  attnderror' id='firstname"+this.addcolrow+"-msg'>First name is required</div></div><div class='matchday-top-input-box half mb'> <input type='text' placeholder='Last Name' id='lastname"+this.addcolrow+"' class='input-style'><div class='invalid-feedback  attnderror' id='lastname"+this.addcolrow+"-msg'>Last name is required</div></div><div class='matchday-top-input-box half mr mb'><input type='number' placeholder='Mobile Number' id='mobilenumber"+this.addcolrow+"' class='input-style'><div class='invalid-feedback  attnderror' id='mobilenumber"+this.addcolrow+"-msg'>Mobile Number is required</div><div class='invalid-feedback  attnderror' id='mobilenumber"+this.addcolrow+"validmsg'>Please enter minimum 10 digit Mobile Number</div></div><div class='matchday-top-input-box half mb'><input type='email' placeholder='Email Address' id='emailaddress"+this.addcolrow+"' class='input-style'><div class='invalid-feedback  attnderror' id='emailaddress"+this.addcolrow+"-msg'>Email is required</div><div class='invalid-feedback  attnderror' id='emailaddress"+this.addcolrow+"validmsg'>Please enter valid email</div></div><div class='matchday-top-input-box full mb'><input type='text' id='address"+this.addcolrow+"' placeholder='Address' class='input-style'><div class='invalid-feedback  attnderror' id='address"+this.addcolrow+"-msg'>Address is required</div></div></div>");
    //this.firstname = jQuery("#firstname2").val();
   
  }


  
  addAttendance(form: NgForm){
    var iserror = 0;
    if(jQuery("#select_match").val() == ''){
      jQuery("#select_match-msg").addClass('active');
      iserror = 1;
    } else{
      jQuery("#select_match-msg").removeClass('active');
    }
    var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var firstnamearr = [];
    var lastnamearr = [];
    var mobilearr = [];
    var emailarr = [];
    var addressarr = [];
    for(let  i = 1; i <=  this.addcolrow; i++){
      if(jQuery("#firstname"+i).val() == ''){
        jQuery("#firstname"+i+"-msg").addClass('active');
        iserror = 1;
      } else{
        jQuery("#firstname"+i+"-msg").removeClass('active');
      }
      if(jQuery("#lastname"+i).val() == ''){
        jQuery("#lastname"+i+"-msg").addClass('active');
        iserror = 1;
      } else{
        jQuery("#lastname"+i+"-msg").removeClass('active');
      }
      if(jQuery("#mobilenumber"+i).val() == ''){
        jQuery("#mobilenumber"+i+"-msg").addClass('active');
        iserror = 1;
      } 
      else if( jQuery("#mobilenumber"+i).val().length < 10 ){

        jQuery("#mobilenumber"+i+"-validmsg").addClass('active');
        jQuery("#mobilenumber"+i+"-msg").removeClass('active');
          iserror = 1;
      }else{
        jQuery("#mobilenumber"+i+"-validmsg").removeClass('active');
        jQuery("#mobilenumber"+i+"-msg").removeClass('active');
      }
      if(jQuery("#emailaddress"+i).val() == ''){
        jQuery("#emailaddress"+i+"-msg").addClass('active');
        iserror = 1;
      } 
      else if(!regex.test(jQuery("#emailaddress"+i).val())){

        jQuery("#emailaddress"+i+"-validmsg").addClass('active');
        jQuery("#emailaddress"+i+"-msg").removeClass('active');
        iserror = 1;
      } 
      else{
        jQuery("#mobilenumber"+i+"-validmsg").removeClass('active');
        jQuery("#emailaddress"+i+"-msg").removeClass('active');
      }
      if(jQuery("#address"+i).val() == ''){
        jQuery("#address"+i+"-msg").addClass('active');
        iserror = 1;
      } else{
        jQuery("#address"+i+"-msg").removeClass('active');
      }
      if (jQuery('#attendencecheck').is(":checked")){
        jQuery("#attendencecheck-msg").removeClass('active');
        
      }else{
        jQuery("#attendencecheck-msg").addClass('active');
        iserror = 1;
      }
      this.firstname = jQuery("#firstname"+i).val();
      this.lastname = jQuery("#lastname"+i).val();
      this.mobilenumber = jQuery("#mobilenumber"+i).val();
      this.emailaddress = jQuery("#emailaddress"+i).val();
      this.address = jQuery("#address"+i).val();
      firstnamearr.push(this.firstname);
      lastnamearr.push(this.lastname);
      mobilearr.push(this.mobilenumber);
      emailarr.push(this.emailaddress);
      addressarr.push(this.address);
    }
    //this.addressRequest.full_name = this.addressRequest.first_name + " "+this.addressRequest.last_name
   
   
    if (form.valid) {
     
      if(iserror==1){
        return false;
      }else{
      this.attendanceRequest.firstname = firstnamearr;
      this.attendanceRequest.lastname = lastnamearr;
      this.attendanceRequest.mobile_no = mobilearr;
      this.attendanceRequest.email = emailarr;
      this.attendanceRequest.address = addressarr;
      console.log(firstnamearr);
      
      let request:any = {
       
      };
      request = Object.assign({}, this.attendanceRequest);
      //console.log(request);
      this.allpagesService.Addattendance(request).then(
        (res) => {
          console.log(res);
          if(res.status==0)
          {
            this.attendanceError = res.message;
          }else{
            this.attendanceSuccess = "Thank you for completing the contact details form. This has been submitted successfully.";
            form.reset(); 
            
          }
            
        
        }).catch((err) => {
          console.log(err);
          this.attendanceError = err.error.message;
        });
        
      }    
         
    }
    
  }
}
